var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CheckBoxRenderer__root"},[_c('CheckBox',{attrs:{"disabled":_vm.disable,"value":_vm.value},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }